<template>
  <div>
    <headerTop ref="store"></headerTop>
    <!-- <headerSearch></headerSearch> -->
    <div class="wrapper">
      <div class="flex">
        <li
          style="width: 156px"
          @click="enquirylb"
          :class="tabs == '0' ? 'red' : 'color43'"
        >
          <span class="fz28 bold" style="font-size: 18px"
            >询价列表(
            <span class="fz28 bold" style="color: red; font-size: 18px">{{
              xjnum
            }}</span>
            )</span
          >
        </li>
        <li
          style="width: 156px"
          @click="quotelb"
          :class="tabs == '1' ? 'red' : 'color43'"
        >
          <span style="font-size: 18px" class="fz28 bold"
            >报价列表(
            <span class="fz28 bold" style="color: red; font-size: 18px">{{
              bjnum
            }}</span>
            )</span
          >
        </li>
      </div>
      <div class="xjsearch" v-show="tabs == '0'">
        <!-- 搜索 -->
        <div class="w11">
          <Row>
            <Col>
              <Input
                type="text"
                style="width: 240px; margin-right: 10px"
                v-model="enquirysearch.odd"
                placeholder="单号"
              />
            </Col>
            <Col>
              <Select
                clearable
                style="width: 160px; margin-right: 10px"
                v-model="enquirysearch.state"
                placeholder="状态"
              >
                <Option
                  v-for="item in statelist"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </Col>
            <Col>
              <Input
                style="width: 160px; margin-right: 10px"
                type="text"
                v-model="enquirysearch.code"
                placeholder="配件编码/配件名称"
              />
            </Col>
            <Col>
              <Select
                clearable
                style="width: 160px"
                v-model="enquirysearch.inquirer"
                placeholder="询价人"
              >
                <Option
                  v-for="item in cityList"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </Col>
            <Col>
              <Button
                @click="
                  pager.current = 1
                  enquiryss()
                "
                class="bt ml30"
                style="background-color: rgb(73, 135, 242); color: #fff"
                >搜索</Button
              >
            </Col>
          </Row>
        </div>
        <div v-show="dataList.length > 0">
          <Page
            style="padding: 0; margin: 0"
            :total="pager.total"
            :current="pager.current"
            :page-size="pager.size"
            :page-size-opts="[30]"
            size="small"
            show-total
            show-sizer
            @on-change="changeCurrentxj"
            @on-page-size-change="changeSizexj"
          />
        </div>
        <!-- 表格 -->
        <!-- 表头 -->
        <Row class="tableHeader">
          <Col span="3">单号</Col>
          <Col span="1">状态</Col>
          <Col style="width: 200px">询价信息</Col>
          <Col style="width: 200px">商品信息</Col>
          <Col span="2">发货地</Col>
          <Col span="1">询价数量</Col>
          <Col style="width: 150px">报价信息</Col>
          <Col style="width: 88px">单价</Col>
          <Col span="2">金额</Col>

          <Col style="width: 110px">操作</Col>
        </Row>
        <div class="table">
          <transition-group
            name="more"
            v-bind:css="false"
            v-on:before-enter="beforeEnter"
            v-on:enter="enter"
          >
            <div
              class="tableCenter"
              v-for="(item, index) in dataList"
              :key="item.id"
            >
              <Row>
                <Col span="3" style="font-size: 12px; font-weight: 700">
                  <div>{{ item.id }}</div>
                </Col>
                <Col span="1" style="font-size: 12px">
                  <span
                    style="font-size: 12px; color: #ff5e00"
                    v-if="item.status === 1"
                    >{{ item.statusCode }}</span
                  >
                  <span
                    style="font-size: 12px; color: #47c460"
                    v-if="item.status === 2"
                    >{{ item.statusCode }}</span
                  >
                  <span
                    style="font-size: 12px; color: #9d9d9d"
                    v-if="item.status === 3 || item.status === 4"
                    >{{ item.statusCode }}</span
                  >
                  <!-- <span style="font-size:12px" v-if="item.status == 4">{{item.statusCode}}</span> -->
                </Col>
                <Col style="width: 200px; font-size: 12px">
                  <div>
                    <!-- 这期隐藏 -->
                    <div @click="xjskip(item)">{{ item.enquiryTname }}</div>
                    <!-- <div>{{ item.enquiryTname }}</div> -->
                    <div>{{ item.enquirySname }}</div>
                    <div>{{ item.createTime }}</div>
                  </div>
                </Col>
                <Col
                  style="
                    width: 200px;
                    text-align: left;
                    justify-content: flex-start;
                    font-size: 12px;
                  "
                >
                  <div class="w22">
                    <div class="original">
                      <div v-show="item.qualityTypeId" class="partType">
                        {{ item.qualityTypeName }}
                      </div>
                      <!-- <Tooltip 
                        :content="
                          item.carBrandName +
                            item.direction +
                            item.stdNameJp +
                            item.oeCode
                        "
                         placement="bottom"
                        style="max-width: 300px"
                      >
                        <div @click="skipxq(item)" class="original-name">
                          {{ item.carBrandName }}{{ item.direction
                          }}{{ item.stdNameJp }}{{ item.oeCode }}
                        </div>
                      </Tooltip> -->
                      <Tooltip
                        :content="item.partComplexName"
                        placement="bottom"
                        max-width="300"
                      >
                        <div @click="skipxq(item)" class="original-name">
                          {{ item.partComplexName }}
                        </div>
                      </Tooltip>
                      <!-- <div @click="skipxq(item)">
                        {{ item.carBrandName }}{{ item.direction
                        }}{{ item.stdNameJp }}{{ item.oeCode }}
                      </div> -->
                    </div>
                    <div class="pledge" style="font-size: 12px">
                      <ul  style="font-size: 12px">
                        <li
                          v-show="item.genuineGuarantee"
                          style="font-size: 12px"
                        >
                          <span class="iconfont icon-a-lujing153"></span>
                          <!-- <span style="font-size: 12px">正品保证</span> -->
                        </li>

                        <li v-show="item.technicalSupport">
                          <span class="iconfont icon-a-ziyuan4"></span>
                          <!-- <span style="font-size: 12px">技术支持</span> -->
                        </li>

                        <li v-show="item.warrantyService">
                          <span class="iconfont icon-a-ziyuan5"></span>
                          <!-- <span style="font-size: 12px">保修服务</span> -->
                        </li>

                        <li v-show="item.returnPromise">
                          <span class="iconfont icon-a-ziyuan21"></span>
                          <!-- <span style="font-size: 12px">退换货承诺</span> -->
                        </li>
                      </ul>
                    </div>
                    <div class="oe-p" @mouseleave="closeRelevance(index)">
                  OE号：
                     <span
                     class="oe-w1"
                    @mouseenter="getRelevance(item.partId, index, item)"
                    v-if="item.oeCodeList"
                  >
                    {{ item.oeCodeList[0]
                    }}
                    <i
                      v-if="item.oeCodeList&&item.oeCodeList.length > 1"
                      class="ivu-icon ivu-icon-ios-arrow-down"
                    ></i>
                  </span>
                  <div
                    class="relevance"
                    :tabIndex="1"
                    v-if="item.oeCodeList&&item.oeCodeList.length > 1"
                  >
                    <div
                      class="relevanceBox"
                      :class="item.isShow ? 'show' : ''"
                    >
                      <p v-for="i in item.oeCodeList.slice(1)" :key="i">
                        {{ i }}
                      </p>
                    </div>
                  </div>
                    </div>
                  </div>
                </Col>
                <!-- 发货地 -->
                <Col span="2" style="font-size: 15px">
                  <span style="font-size: 13px"
                    >{{ item.shipCity }}{{ item.shipStore }}</span
                  >
                </Col>
                <Col span="1" style="font-size: 12px">{{
                  item.enquiryNum
                }}</Col>
                <Col style="width: 150px; font-size: 12px">
                  <div>
                    <div @click="bjskip(item)">{{ item.offerTname }}</div>
                    <div>{{ item.offerSname }}</div>
                    <div>{{ item.makeOfferTime }}</div>
                  </div>
                </Col>
                <Col style="width: 88px">
                  <div style="color: red" class="bold" v-if="item.offerPrice">
                    ￥{{ item.offerPrice }}
                  </div>
                  <div v-else style="color: red">--</div>
                </Col>
                <Col span="2" style="font-size: 12px">
                  <span style="color: red" class="bold" v-if="item.totalMoney"
                    >￥{{ item.totalMoney }}</span
                  >
                  <span v-else style="color: red">--</span>
                </Col>

                <Col span="2">
                  <div class="w122">
                    <div style="font-size: 15px">
                      <span
                        style="font-size: 15px; color: #ff7700"
                        class="iconfont icon-a-lujing156 mr5"
                      ></span>
                      <span style="font-size: 13px; line-height: 28px">{{
                        item.timer ? item.timer : '00小时00分'
                      }}</span>
                    </div>
                    <div>
                      <div
                        class="buy"
                        style="font-size: 12px"
                        v-show="item.status == 2"
                      >
                        <span
                          class="iconfont icon-gouwuche"
                          title="加入购物车"
                          @click="setShopCat(item, index)"
                        ></span>
                        <div>
                          <Button
                            class="purchase"
                            @click="prebuy(item)"
                            :loading="item.buyLoading"
                            style="border: none"
                            >立即购买</Button
                          >
                        </div>
                      </div>
                      <div
                        class="nobuy"
                        span="2"
                        v-show="
                          item.status == 1 ||
                          item.status == 3 ||
                          item.status == 4
                        "
                      >
                        <span
                          class="iconfont icon-gouwuche"
                          title="加入购物车"
                        ></span>
                        <div>
                          <Button style="border: none" class="purchase"
                            >立即购买</Button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <!-- <Col> </Col> -->
              </Row>
            </div>
          </transition-group>
          <!-- 询价为空 -->
          <div class="emptyData" v-show="dataList.length == 0">
            <div class="min">
              <span
                style="font-size: 14px; padding: 0 9px 0 5px"
                class="iconfont icon-gantanhao-xianxingyuankuang"
              ></span>
              <span style="font-size: 14px">抱歉！没找到你想要的数据~!</span>
            </div>
          </div>
          <!-- 加载中 -->
          <div class="demo-spin-container" v-if="spinShow">
            <Spin fix></Spin>
          </div>
        </div>
        <div class="pagefy" v-show="dataList.length > 0">
          <Page
            :total="pager.total"
            :current="pager.current"
            :page-size="pager.size"
            :page-size-opts="[30]"
            size="small"
            show-total
            show-sizer
            @on-change="changeCurrentxj"
            @on-page-size-change="changeSizexj"
          />
        </div>
      </div>
      <div class="bjsearch" v-show="tabs == '1'">
        <quote ref="quote"></quote>
      </div>
    </div>
    <Footer></Footer>
    <footerP></footerP>
    <slider></slider>
  </div>
</template>

<script>
import headerTop from '@/views/base/common/header-top.vue'
// import headerSearch from '@/views/base/common/header-search.vue'
import Footer from '@/views/base/common/footer.vue'
import footerP from '@/views/base/common/footer-p.vue'
import slider from '@/views/base/common/slider.vue'
import quote from '@/views/askquote/quote.vue'
import {
  getinquireman,
  getinquirelist,
  getenquiryadd
} from '@/api/askoffer/askquote'
import { prebuy } from '@/api/goodsList.js'
import { getenquirysj } from '@/api/home'
export default {
  components: { headerTop, Footer, footerP, quote, slider },
  data() {
    return {
      tabs: '0', // tbas切换
      enquirysearch: {
        odd: '', // 单号
        state: '', //状态
        code: '', //编码
        inquirer: '' // 询价人
      }, // 询价搜索
      statelist: [
        {
          id: '1',
          name: '等待报价'
        },
        {
          id: '2',
          name: '报价完成'
        },
        {
          id: '3',
          name: '已过期'
        }
      ], //状态列表
      cityList: [], // 询价人
      spinShow: false, // 加载
      dataList: [
        {
          id: '', // 单号
          status: '', // 状态
          enquiryTname: '', // 询价店铺
          enquirySname: '', // 询价名字
          createTime: '', // 询价时间
          qualityTypeId: '', // 询价原厂件
          carBrandName: '', //品牌
          direction: '', //方向
          stdNameJp: '', // 标准名称
          oeCode: '', // 编码
          genuineGuarantee: '', // 正品保障
          technicalSupport: '', // 技术支持
          warrantyService: '', // 保修服务
          returnPromise: '', //退换货承诺
          enquiryNum: '', // 询价数量
          offerTname: '', // 报价信息店铺
          offerSname: '', //报价人
          makeOfferTime: '', //报价时间
          offerPrice: '', // 单价
          totalMoney: '', // 金额
          endTime: '' //有效期
        }
      ],
      xjnum: '', // 询价数量
      bjnum: '', // 报价数量
      timer: null,
      // 分页
      pager: {
        current: 1,
        total: 0,
        size: 30
      },
      tenantId: JSON.parse(localStorage.getItem('userdetails_tenantInfo'))
        .tenantId,
      timerinit: [] // 时间指示器
    }
  },
  created() {
    this.enquirystaff()
    this.enquirylist()
    this.getenquirydata()
  },
  // beforeDestroy() {
  //   if (this.timer) {
  //     //如果定时器还在运行 或者直接关闭，不用判断
  //     clearInterval(this.timer) //关闭
  //     this.timer = null
  //   }
  // },
  methods: {
    // 询价列表
    async enquirylist() {
      this.spinShow = true
      var pattern = /^\d+$/g
      
      this.enquirysearch.odd = this.enquirysearch.odd.replace(/\s*/g, '')
      console.log(this.enquirysearch.odd);
      if (this.enquirysearch.odd) {
        var result = this.enquirysearch.odd.match(pattern)
        if (result == null) {
          this.$Message.error('请输入正确的单号')
        } else {
          let params = {
            current: this.pager.current,
            size: this.pager.size
          }
          let data = {
            id: this.enquirysearch.odd,
            tenantId: this.tenantId,
            status: this.enquirysearch.state ? this.enquirysearch.state : '-1',
            codeAndName: this.enquirysearch.code,
            enquirySid: this.enquirysearch.inquirer
              ? this.enquirysearch.inquirer + ''
              : '-1'
          }
          const res = await getinquirelist(data, params)

          if (res.status) {
            res.data.records.map((item) => (item.timer = ''))
            this.dataList = res.data.records
            this.pager.total = res.data.total
            for (let i = 0; i <= this.timerinit.length; i++) {
              clearInterval(this.timerinit[i])
            }
            this.timerinit = []
            let b = new Date().getTime()
            this.dataList.forEach((item, index) => {
              item.endTime = parseInt(
                (new Date(item.endTime).getTime() - b) / 1000
              )
              if (item.endTime > 0) {
                this.timerinit[index] = setInterval(() => {
                  this.showTime(item.endTime--, this.timerinit[index], index)
                }, 1000)
              } else {
                clearInterval(this.timerinit[index])
              }
            })
          }
        }
        // var result = this.enquirysearch.odd.match(pattern)
        // if (result == null) {
        //   this.$Message.error('请检查单号是否正确');
        // }
      } else {
        let params = {
          current: this.pager.current,
          size: this.pager.size
        }
        let data = {
          id: this.enquirysearch.odd,
          tenantId: this.tenantId,
          status: this.enquirysearch.state ? this.enquirysearch.state : '-1',
          codeAndName: this.enquirysearch.code,
          enquirySid: this.enquirysearch.inquirer
            ? this.enquirysearch.inquirer + ''
            : '-1'
        }
        const res = await getinquirelist(data, params)

        if (res.status) {
          res.data.records.map((item) => (item.timer = ''))
          this.dataList = res.data.records
          this.pager.total = res.data.total
          for (let i = 0; i <= this.timerinit.length; i++) {
            clearInterval(this.timerinit[i])
          }
          this.timerinit = []
          let b = new Date().getTime()
          this.dataList.forEach((item, index) => {
            item.endTime = parseInt(
              (new Date(item.endTime).getTime() - b) / 1000
            )
            if (item.endTime > 0) {
              this.timerinit[index] = setInterval(() => {
                this.showTime(item.endTime--, this.timerinit[index], index)
              }, 1000)
            } else {
              clearInterval(this.timerinit[index])
            }
          })
        }
      }
      this.spinShow = false
    },
    // 询价与报价数量
    async getenquirydata() {
      const res = await getenquirysj()
      if (res.status) {
        this.xjnum = res.data.enquiryNum
        this.bjnum = res.data.offerNum
      }
    },
    // 定时器
    showTime(item, interval, index) {
      if (item < 0) {
        if (interval) clearInterval(interval)
      }
      if (this.$route.name != 'askquote') {
        clearInterval(interval)
        return
      }
      let hour =
        parseInt((item % (60 * 60 * 24)) / (60 * 60)) >= 10
          ? parseInt((item % (60 * 60 * 24)) / (60 * 60))
          : '0' + parseInt((item % (60 * 60 * 24)) / (60 * 60))
      let min =
        parseInt((item % (60 * 60)) / 60) >= 10
          ? parseInt((item % (60 * 60)) / 60)
          : '0' + parseInt((item % (60 * 60)) / 60)
      let sec = item % 60 >= 10 ? item % 60 : '0' + (item % 60)
      let text = hour + '小时' + min + '分'
      if (interval && this.dataList.length > 0)
        this.dataList[index].timer = text
      // if (this.$route.name != 'askquote') {
      //   for (let i = 1; i <= interval; i++) {
      //     clearInterval(i)
      //   }
      // }
    },
    // 跳转详情
    skipxq(item) {
      this.$router.push({
        path: '/Partsdetails',
        query: {
          partId: item.partId
        }
      })
    },
    // 询价跳转店铺
    xjskip(item) {
      this.$router.push({
        path: '/homePage',
        query: {
          tenantId: item.enquiryTid,
          shopName: item.enquiryTname
        }
      })
    },
    // 报价跳转店铺
    bjskip(item) {
      this.$router.push({
        path: '/homePage',
        query: {
          tenantId: item.offerTid,
          shopName: item.offerTname
        }
      })
    },
    // 这是张海波写的
    //   if (res.status) {
    //     res.data.list.map(item => (item.timer = ''))
    //     this.dataList = res.data.list
    //     let timerinit = []
    //     this.dataList.forEach((item, ind) => {
    //       if (timerinit[ind]) clearInterval(timerinit[ind])
    //       let jj = new Date(item.endTime).getTime() - new Date().getTime()
    //       let time = parseInt(jj / 1000)
    //       if (time > 0) {
    //         // this.showTime(time, null, ind)
    //         timerinit[ind] = setInterval(() => {
    //           this.showTime(time--, timerinit[ind], ind)
    //         }, 1000)
    //       }
    //     })
    //   }
    // },
    // 这是张海波写的
    // showTime(time, interval, index) {
    //   if (time < 0) {
    //     if (interval) clearInterval(interval)
    //   }
    //   let min =
    //     Math.floor(time / 60) >= 10
    //       ? Math.floor(time / 60)
    //       : '0' + Math.floor(time / 60)
    //   let second = time % 60 >= 10 ? time % 60 : '0' + (time % 60)
    //   let h =
    //     Math.floor(min / 60) >= 10
    //       ? Math.floor(min / 60)
    //       : '0' + Math.floor(min / 60)
    //   let mins =
    //     Math.floor(min % 60) >= 10
    //       ? Math.floor(min % 60)
    //       : '0' + Math.floor(min % 60)
    //   let text = h + ':' + mins + ':' + second
    //   if (interval) this.dataList[index].timer = text
    // },
    // 询价人
    async enquirystaff() {
      const res = await getinquireman({
        tenantId: this.tenantId
      })
      if (res.status) {
        this.cityList = res.data
      }
    },
    // 询价
    enquirylb() {
      this.tabs = '0'
    },
    // 报价
    quotelb() {
      this.tabs = '1'
      this.$refs.quote.quotestaff()
      this.$refs.quote.quotelist1()

    },
    // 询价搜索
    enquiryss() {
      this.enquirylist()
    },
    // 加入购物车
    async setShopCat(item) {
      let data = {
        enquiryOfferId: item.id,
        enquiryTid: item.enquiryTid,
        enquirySid: item.enquirySid,
        offerTid: item.offerTid,
        offerTname: item.offerTname,
        partId: item.partId,
        enquiryNum: item.enquiryNum,
        offerPrice: item.offerPrice,
        totalMoney: item.totalMoney,
        storeId: item.storeId
      }
      const res = await getenquiryadd(data)
      if (res.status) {
        this.$refs.store.getCount()
        this.$Message.success('加购成功！')
      }
    },
    // 立即购买
    async prebuy(item) {
      let data = {
        enquiryOfferId: item.id,
        partId: item.partId,
        tenantId: item.offerTid,
        partNum: item.enquiryNum,
        shopId: item.shopId,
        storeId: item.storeId
      }
      const res = await prebuy(data)
      if (res.status) {
        this.$router.push({
          path: '/orderInformation',
          query: {
            pid: res.data.previewOrderId
          }
        })
      }
    },
    // 点击分页(1,2,3)
    changeCurrentxj(current) {
      this.pager.current = current
      this.enquirylist()
    },
    // 分页选择
    changeSizexj(size) {
      this.pager.size = size
      this.enquirylist()
    },
    // 入场动画之前---
    beforeEnter(el) {
      el.style.opacity = 0
    },
    // 入场动画过程中
    enter(el, done) {
      let delay = el.dataset.index * 100
      setTimeout(() => {
        el.style.transition = 'opacity 0.4s '
        el.style.opacity = 1
        el.style.animation = 'one-in 0.4s infinite'
        el.style['animation-iteration-count'] = 1
        done()
      }, delay)
    },
    // 展开
     getRelevance(partId, index, item) {
      console.log(partId)
      console.log(item)
      this.$set(this.dataList[index], 'isShow', true)
    },
    // 关闭oe
    closeRelevance(index) {
      console.log(index)
      this.$set(this.dataList[index], 'isShow', false)
    },
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
